<template>
  <div class="notification-bar notification-bar--toast" :class="[showNotificationClass, notificationTypeClass]">
    <div v-if="notification" class="notification-bar__container">
      {{ notification.message }}
    </div>

    <button class="notifcation-bar__desmiss" @click="desmissNotification()">
      <oie-use-svg svg="circle-plus" color="currentColor" class="svg--45"></oie-use-svg>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  data: () => ({
    notification: null,
    activeNotifications: []
  }),
  computed: {
    ...mapGetters('ui', ['notifications']),
    showNotificationClass() {
      return this.notification && 'notification-bar--is-visible'
    },
    notificationTypeClass() {
      if (this.notification === null) {
        return
      }

      const notificationType = this.notification.type === null ? 'success' : this.notification.type
      return this.notification && `notification-bar--is-${notificationType}`
    }
  },
  watch: {
    notifications() {
      const notification = _.last(this.notifications)

      if (!notification || notification.destination === undefined || notification.destination !== 'main') {
        return
      }

      this.notification = notification
      this.activeNotifications.push(notification)

      // Errors stay up longer than the two seconds a success toast gets, unless the server or the
      // caller says otherwise (OC-3039).
      const defaultDuration = notification.type === 'error' ? 5000 : 2000

      setTimeout(() => {
        this.notification = null
        this.activeNotifications.remove(notification)
      }, notification.duration || defaultDuration)
    }
  },
  methods: {
    desmissNotification() {
      this.notification = null
    }
  }
}
</script>

<style lang="scss">
.notification-bar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-.5rem);
  transition: all 0ms;
  color: color(text);
  z-index: 13;
}

.notification-bar--toast {
  position: fixed;
  top: 4rem;
  right: 0;
  left: 0;
  width: auto;
  border-radius: 3px;
  z-index: 200;
  box-shadow: -3px 7px 16px 0 rgba(0, 0, 0, 0.3);

  @include media(medium) {
    top: measure(container-distance);
    right: measure(container-distance);
    left: initial;
    max-width: 21rem;
  }
}

.notification-bar--is-visible {
  opacity: 1;
  visibility: visible;
  transition: all 140ms ease-in;
}

.notification-bar--is-success {
  background-color: color(background-green-bar);
}

.notification-bar--is-warning {
  background-color: color(message-warning);
}

.notification-bar--is-error {
  background-color: color(message-error);
  color: color(text-inverted);
}

.notification-bar__container {
  @include container(false);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 3.125rem;
  padding-top: measure(quarter);
  padding-right: measure(double) !important;
  padding-bottom: measure(quarter);
  padding-left: measure(half) !important;
}

.notifcation-bar__desmiss {
  @include reset-button;
  position: absolute;
  top: 50%;
  right: 0;
  padding-right: measure(quarter);
  transform: translateY(-50%);
  overflow: hidden;
}

.notification-bar--is-warning .notifcation-bar__desmiss {
  color: color(text);
}

.notification-bar--is-error .notifcation-bar__desmiss {
  color: color(text-inverted);
}

.notifcation-bar__desmiss > svg {
  width: 1.5rem;
  height: 1.5rem;
}
</style>
